import { Box, CircularProgress, Typography } from "@material-ui/core";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useIntl } from "../../../../_metronic/i18n/customUseIntl";
import type { AppNotification } from "../../models/Notification/notificationTypes";
import { notificationPopoverStyles } from "../../../ThemeProvider";

type NotificationPopoverBodyProps = {
  notifications: AppNotification[];
  isLoading: boolean;
  error: Error | null;
  onNotificationClick: (notification: AppNotification) => void;
};

const toPlainText = (str: string): string =>
  str
    .replace(/(<([^>]+)>)/gi, "")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#039;/gi, "'")
    .replace(/&nbsp;/gi, " ");

const NotificationPopoverBody = ({
  notifications,
  isLoading,
  error,
  onNotificationClick,
}: NotificationPopoverBodyProps) => {
  const intl = useIntl();
  const classes = notificationPopoverStyles();

  if (isLoading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height={360}
      >
        <CircularProgress size={32} />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height={360}
        padding={3}
      >
        <Typography
          variant="body1"
          color="error"
          style={{ textAlign: "center" }}
        >
          {intl.formatMessage({ id: "NOTIFICATIONS.LOAD_ERROR" })}
        </Typography>
      </Box>
    );
  }

  if (notifications.length > 0) {
    return (
      <Box className={classes.notificationsContainer}>
        {notifications.map((notification) => (
          <Box
            key={notification.id}
            component="div"
            className={classes.notificationItem}
            onClick={() => onNotificationClick(notification)}
          >
            <Typography variant="h6">{notification.title}</Typography>
            <Box component="div" className={classes.notificationPreview}>
              {toPlainText(notification.message)}
            </Box>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box className={classes.noNotifications}>
      <Typography variant="h5">
        {intl.formatMessage({ id: "NOTIFICATIONS.NO_NOTIFICATIONS" })}
      </Typography>
      <Typography
        color="textSecondary"
        variant="body1"
        style={{ maxWidth: 260, textAlign: "center" }}
      >
        {intl.formatMessage({
          id: "NOTIFICATIONS.NO_NOTIFICATIONS.INFO",
        })}
      </Typography>
      <SVG src={toAbsoluteUrl("/media/svg/icons/General/mailbox.svg")} />
    </Box>
  );
};

export default NotificationPopoverBody;
